<template>
  <div>
    <div id="home">
      <div class="status">
        <span class="act">
          1
        </span>
        <p></p>
        <span>
          2
        </span>
        <p></p>
        <span>
          3
        </span>
      </div>
      <h1>입사일을 입력해 주세요</h1>
      <div style="width: 100%;border: 1px solid #DCDFE6;padding: 5px 15px;color: #333;margin-top: 30px;" @click="showPicker = true">
        <i class="el-icon-date"></i>
        {{value}}
      </div>
      <div class="btn" @click="next()" :class="value !== ''?'btnAct':''">
        다음
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title=""
          :formatter="formatter"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="handleConfirm"
          cancel-button-text="Cancel"
          confirm-button-text="Confirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { Button, Popup, DatetimePicker } from 'vant';
  import 'vant/lib/index.css';
  export default {
    name: 'JoinDate',
    components: {
      VanPopup: Popup,
      VanDatetimePicker: DatetimePicker,
    },
    data() {
      return {
        value:'',
        showPicker: false,
        currentDate: new Date(),
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2100, 11, 31)
      }
    },
    created(){
      if(Vue.ls.get('joinDate')) {
        this.value = Vue.ls.get('joinDate')
        this.currentDate = new Date(Vue.ls.get('joinDate'));
      }
    },
    methods:{
      moment,
      formatter(type, value) {
        if (type === 'year') return `${value}`;
        if (type === 'month') return `${value}`;
        if (type === 'day') return `${value}`;
        return value;
      },
      handleConfirm(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        this.value = `${year}-${month}-${day}`;
        this.showPicker = false;
      },
      next(){
        if(this.value !== ''){
          Vue.ls.set("joinDate", this.value)
          this.$router.push('/leaveDate')
        }
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;}
  h1{color:#333333;font-size: 22px;}
  .btn{background:#EBECF0;color:#A8A8BC;display: flex;position: fixed;bottom:20px;justify-content: center;margin-top:30px;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .btnAct{background:#4873FF;color:#ffffff;}
  .status{display: flex;align-items: center;padding:40px;width: 100%;}
  .status span{width: 30px;height: 30px;display: flex;flex-shrink: 0;margin:0 10px;justify-content: center;align-items: center;color:#717B85;font-weight: bold;background-color: #EBECF0;border-radius: 50%;}
  .status .act{background-color: #C9D6FF;color: #003DFF;}
  .status p{background-color: #EDEEF2;height: 1px;width: 100%;}
</style>
